// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VAaf0czASmOoqUDyzUlG{display:inline;line-height:0}`, "",{"version":3,"sources":["webpack://./src/elements/device-icon.module.scss"],"names":[],"mappings":"AAAA,sBACC,cAAA,CACA,aAAA","sourcesContent":[".wrapper {\n\tdisplay: inline;\n\tline-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `VAaf0czASmOoqUDyzUlG`;
export default ___CSS_LOADER_EXPORT___;
